import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map,switchMap } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerProposalsEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.consumerProposals.getApi),
			switchMap((action) =>
				this.adminService.consumerProposals(action.id).pipe(
					map((consumerProposals) =>
						MpAdminActions.consumerProposals.getSuccess({
							consumerProposals,
							loading: false
						})
					),
					catchError((error) =>
						of(MpAdminActions.consumerProposals.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private adminService: MpAdminService
	) {}
}
